/**
 * P&L days are the UTC date of when the sale happened (`occurred_at.toISOString().slice(0, 10)` on the server), so
 * date filters use the same.
 */
export const ymd = (date: Date) => date.toISOString().slice(0, 10)

export const daysAgo = (n: number) => ymd(new Date(Date.now() - n * 24 * 3600 * 1000))

export const monthStart = () => {
  const now = new Date()
  return ymd(new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1)))
}
